<template>
  <!-- MODAL PARA HACER PAGOS -->
  <div
    class="modal fade"
    id="hacerPago"
    tabindex="-1"
    role="dialog"
    aria-labelledby="reportarPago"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
      <div class="modal-content">
        <div
          class="modal-header d-flex justify-content-between align-items-center"
        >
          <h5 class="modal-title" id="reportarPago">Pagos</h5>

          <div class="modal-actions">
            <PlanPago
              :fechaPago="this.hacerPagoInfo.fechaOtorgamiento"
              :monto="this.hacerPagoInfo.montoAprobado"
              :frecuenciaPago="this.hacerPagoInfo.frecuenciaPago"
              :interes="this.hacerPagoInfo.tasaInteres"
              :plazoPago="this.hacerPagoInfo.plazoPago"
              :producto="this.hacerPagoInfo.producto"
              :periodoGracia="this.hacerPagoInfo.periodoGracia"
              :fechaFija="this.hacerPagoInfo.fechaFija"
              :pagosInteres="
                this.hacerPagoInfo.pagosInteres
                  ? this.hacerPagoInfo.pagosInteres
                  : []
              "
              :disabled="!pagoInfoReady"
            />

            <button
              @click="handleImprimirEstadoCuenta()"
              type="button"
              class="btn btn-success btn-estado"
              :disabled="!pagoInfoReady"
            >
              <i class="fa-solid fa-download me-2"></i>Estado de Cuenta
            </button>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body">
          <div class="row g-3 payment-layout">
            <table class="datos-table d-none">
              <tr>
                <td>
                  <b
                    >{{ this.hacerPagoInfo?.nombres }}
                    {{ this.hacerPagoInfo?.apellidos }}</b
                  >
                </td>
              </tr>
              <tr>
                <td>{{ this.hacerPagoInfo?.dni }}</td>
              </tr>
            </table>

            <div class="col-12 col-lg-7">
              <div v-if="!pagoInfoReady" class="payment-loading">
                <div class="spinner-border text-secondary" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
                <p>Cargando información...</p>
              </div>

              <div v-else class="credit-summary">
                <div class="client-plain">
                  <h5 class="client-name">
                    {{ this.hacerPagoInfo.nombres }}
                    {{ this.hacerPagoInfo.apellidos }}
                  </h5>
                  <p class="client-dni">{{ this.hacerPagoInfo.dni }}</p>

                  <section class="summary-totals client-totals">
                    <div class="total-card">
                      <span class="total-label">
                        Total Saldo Vencido a pagar(A la fecha)
                      </span>
                      <strong class="total-value">
                        {{
                          this.hacerPagoInfo?.totalMinimoAPagar > 0
                            ? this.formatoNumero(
                                this.hacerPagoInfo?.totalMinimoAPagar
                              )
                            : "0.00"
                        }}
                        {{ this.moneda }}
                      </strong>
                    </div>

                    <div class="total-card total-card-strong">
                      <span class="total-label">
                        Total Saldo a pagar para cancelación(A la fecha)
                      </span>
                      <strong class="total-value">
                        {{
                          this.hacerPagoInfo?.totalMontoCancelar > 0
                            ? this.formatoNumero(
                                this.hacerPagoInfo?.totalMontoCancelar
                              )
                            : "0.00"
                        }}
                        {{ this.moneda }}
                      </strong>
                    </div>
                  </section>
                </div>

                <section class="summary-group">
                  <div class="summary-grid summary-grid-three">
                    <div
                      v-if="this.hacerPagoInfo.diasInteresVencimiento"
                      class="summary-item"
                    >
                      <span class="summary-label">
                        Días Interés desde vencimiento
                      </span>
                      <strong class="summary-value">
                        {{
                          this.hacerPagoInfo.diasInteresVencimiento > 0
                            ? this.hacerPagoInfo?.diasInteresVencimiento
                            : 0
                        }}
                      </strong>
                      <small class="summary-note">
                        desde {{ dateFormat(this.hacerPagoInfo.fechaVencimiento) }}
                      </small>
                    </div>
                    <div v-else class="summary-item">
                      <span class="summary-label">Días Interés</span>
                      <strong class="summary-value">
                        {{ this.hacerPagoInfo?.diasInteres }}
                      </strong>
                      <small class="summary-note">
                        desde {{ dateFormat(this.fechaUltimoPago) }}
                      </small>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">Días Mora</span>
                      <strong class="summary-value">
                        {{ this.hacerPagoInfo?.diasMora }} días
                      </strong>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">Días Cuota Vencida</span>
                      <strong class="summary-value">
                        {{ this.hacerPagoInfo?.diasCuotaSinPagar }}
                      </strong>
                      <small class="summary-note">
                        desde cuota No.{{ this.hacerPagoInfo?.noCuotas }}
                      </small>
                      <span
                        class="summary-status"
                        :class="{
                          'status-ok':
                            this.hacerPagoInfo.diasCuotaSinPagar == 0,
                          'status-late':
                            this.hacerPagoInfo.diasCuotaSinPagar != 0,
                        }"
                      >
                        {{
                          this.hacerPagoInfo.diasCuotaSinPagar == 0
                            ? "Se encuentra al día"
                            : "No se encuentra al día"
                        }}
                      </span>
                    </div>
                  </div>
                </section>

                <section class="summary-group">
                  <div class="summary-grid">
                    <div class="summary-item">
                      <span class="summary-label">
                        Saldo Interés Corriente
                      </span>
                      <strong class="summary-value">
                        {{
                          this.formatoNumero(this.hacerPagoInfo?.interesPorPagar)
                        }}
                        {{ this.moneda }}
                      </strong>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">
                        Saldo Interés Moratorio ({{ this.hacerPagoInfo?.tasaMora }}%)
                      </span>
                      <strong class="summary-value">
                        {{ this.formatoNumero(this.hacerPagoInfo?.moraPorPagar) }}
                        {{ this.moneda }}
                      </strong>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">Saldo Capital Vencido</span>
                      <strong class="summary-value">
                        {{
                          this.formatoNumero(this.hacerPagoInfo?.capitalDebePagar)
                        }}
                        {{ this.moneda }}
                      </strong>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">Saldo de Capital</span>
                      <strong class="summary-value">
                        {{ this.formatoNumero(this.hacerPagoInfo?.saldo) }}
                        {{ this.moneda }}
                      </strong>
                    </div>
                  </div>
                </section>

                <section class="summary-group">
                  <div class="summary-grid">
                    <div class="summary-item">
                      <span class="summary-label">Capital Pagado</span>
                      <strong class="summary-value">
                        {{
                          this.formatoNumero(this.hacerPagoInfo?.capitalAcumulado)
                        }}
                        {{ this.moneda }}
                      </strong>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">Interés Corriente Pagado</span>
                      <strong class="summary-value">
                        {{
                          this.formatoNumero(
                            this.hacerPagoInfo?.totalInteresPagado
                          )
                        }}
                        {{ this.moneda }}
                      </strong>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">Interés Moratorio Pagado</span>
                      <strong class="summary-value">
                        {{
                          this.formatoNumero(this.hacerPagoInfo?.totalMoraPagada)
                        }}
                        {{ this.moneda }}
                      </strong>
                    </div>
                  </div>
                </section>

                <div class="capital-expected">
                  <span class="summary-label">
                    Capital debería tener Acumulado
                  </span>
                  <strong class="summary-value">
                    {{
                      this.formatoNumero(
                        this.hacerPagoInfo?.capitalDeberiaAcumulado
                      )
                    }}
                    {{ this.moneda }}
                  </strong>
                </div>

              </div>
            </div>

            <!-- //Hacer pago -->
            <div class="col-12 col-lg-5">
              <div class="registro-pago">
                <h5>Registrar Pago</h5>
                <div v-if="hacerPagoInfo.pagosInteres">
                  Tipo de Pago: {{ this.tipoPago }}
                </div>
                <div
                  v-if="hacerPagoInfo.pagosInteres"
                  class="ms-4 me-2 d-flex justify-content-between"
                >
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="radioDefault"
                      id="radioDefault1"
                      value="credito"
                      v-model="tipoPago"
                    />
                    <label class="form-check-label" for="radioDefault1">
                      Pago Crédito
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="radioDefault"
                      id="radioDefault2"
                      value="interes"
                      v-model="tipoPago"
                    />
                    <label class="form-check-label" for="radioDefault2">
                      Pago Arreglo Interés
                    </label>
                  </div>
                </div>

                <div class="control">
                  <div class="d-flex justify-content-between align-items-center">
                          <label class="pagos-text" for="fechaPagado"
                            >Fecha de Pago (recibo): 
                          </label>
                          <button class="btn btn-dark dayHoy" @click="this.fechaPagadoHoy()">Hoy</button>
                        
                  </div>
                  <input
                    v-model="this.fechaPagado"
                    type="date"
                    required
                    class="form-control"
                    name="fechaPagado"
                    id="fechaPagado"
                    min="{{this.fechaUltimoPago}}"
                  />
                  <span
                    v-if="
                      this.fechaPagado < this.fechaUltimoPago?.slice(0, 10) &&
                      (!Admin || !modoThanos)
                    "
                    class="text-danger"
                    >La fecha no puede ser menor a la fecha del ultimo
                    pago</span
                  >
                </div>
                <div v-if="!this.Consultor" class="control">
                  <label class="pagos-text" for="montoPago"
                    >Monto a registrar (recibo):
                  </label>
                  <input
                    v-model="this.montoPagado"
                    type="number"
                    required
                    class="form-control"
                    name="montoPago"
                    id="montoPago"
                    min="0"
                  />
                </div>

                <div v-if="!this.Consultor" class="control">
                  <label class="pagos-text" for="montoPago"
                    >Nombre del Banco:
                  </label>
                  <select
                    v-model="this.nombreBanco"
                    type="number"
                    required
                    class="form-select"
                    name="noReferenciaRecibo"
                    id="nombreBanco"
                    min="0"
                  >
                    <option value="" disabled>Seleccione un banco</option>
                    <option
                      v-for="banco in bancos"
                      :key="banco.id || banco.nombreBanco"
                      :value="banco.nombreBanco"
                    >
                      {{ banco.nombreBanco }}
                    </option>
                  </select>
                </div>
                <div
                  class="control"
                  v-if="this.nombreBanco !== '' && !this.Consultor"
                >
                  <label class="pagos-text" for="montoPago"
                    >Numero de Cuenta:
                  </label>
                  <select
                    v-model="this.noCuenta"
                    type="number"
                    required
                    class="form-select"
                    name="noReferenciaRecibo"
                    id="noCuenta"
                    min="0"
                  >
                    <option value="" disabled>Seleccione una cuenta</option>
                    <option
                      v-for="noBanco in numerosDeCuenta"
                      :key="noBanco"
                      :value="noBanco"
                    >
                      {{ noBanco }}
                    </option>
                  </select>
                </div>
                <div v-if="!this.Consultor" class="control">
                  <label for="montoPago">No. Referencia Recibo: </label>
                  <input
                    v-model="this.noReferenciaRecibo"
                    type="number"
                    required
                    class="form-control"
                    name="noReferenciaRecibo"
                    id="noReferenciaRecibo"
                    min="0"
                  />
                </div>
                <div v-if="this.slug !== ''" class="mb-3">
                  <img
                    :src="`${this.imgPath}/covers/${this.slug}.jpg`"
                    class="img-fluid img-thumbnail book-cover"
                    alt="cover"
                  />
                </div>

                <div v-if="!this.Consultor" class="mb-3">
                  <label for="formFile" class="form-label"
                    >Imagen Recibo:</label
                  >
                  <input
                    ref="coverInput"
                    class="native-file-input"
                    type="file"
                    id="formFile"
                    required
                    accept="image/jpeg, image/jpg, image/png"
                    @change="loadCoverImage"
                  />
                  <label class="custom-file-control" for="formFile">
                    <span class="custom-file-button">Seleccionar archivo</span>
                    <span class="custom-file-name">
                      {{ selectedFileName || "Ningún archivo seleccionado" }}
                    </span>
                  </label>
                  <div v-if="isLoading" class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>

                <button
                  v-if="!this.Consultor"
                  class="btn btn-pegar-imagen"
                  @click="pegarImagen"
                >
                  Pegar imagen
                </button>
                <div v-if="imagenPegada">
                  <img
                    class="imagen-recibo"
                    :src="imagenPegada"
                    alt="Imagen pegada"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="estado-verificado">
            <span
              v-if="
                this.hacerPagoInfo.aprobadoCoordinador === false &&
                this.hacerPagoInfo.aprobadoJefe === false
              "
              class="pendiente text-danger"
            >
              <em>
                <small> Pendiente Revisión por Coordinadores </small>
              </em>
            </span>
            <span
              v-else-if="this.hacerPagoInfo.aprobadoCoordinador === false"
              class="pendiente text-danger"
            >
              <em>
                <small>
                  Pendiente Revisión Por Coordinador de la Sucursal
                </small>
              </em>
            </span>
            <span
              v-else-if="this.hacerPagoInfo.aprobadoJefe === false"
              class="pendiente text-danger"
            >
              <em>
                <small>
                  Pendiente Revisión Por Jefe de Acceso Financiero
                </small>
              </em>
            </span>
          </div>
          <!-- v-if="" -->
          <br />
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            @click="cleanData()"
          >
            Cerrar
          </button>

          <button
            v-if="!pagoInfoReady"
            type="button"
            class="btn btn-registrar-pago"
            disabled
          >
            Registrar Pago
          </button>

          <button
            v-else-if="
              this.hacerPagoInfo.aprobadoCoordinador === false ||
              this.hacerPagoInfo.aprobadoJefe === false
            "
            type="button"
            class="btn btn-registrar-pago"
            disabled
          >
            Registrar Pago
          </button>
          <!--  <button v-else-if="this.fechaPagado?.length === ''" type="button" class="btn btn-primary" disabled>Registrar
            Pago</button>-->

          <!-- <button v-else-if="this.fechaPagado > this.hoy()" type="button" class="btn btn-primary" disabled>Registrar
            Pago</button> -->
          <button
            v-else-if="this.montoPagado === 0"
            type="button"
            class="btn btn-registrar-pago"
            disabled
          >
            Registrar Pago
          </button>
          <button
            v-else-if="this.montoPagado === ''"
            type="button"
            class="btn btn-registrar-pago"
            disabled
          >
            Registrar Pago
          </button>

          <button
            v-else-if="!this.Consultor"
            type="button"
            class="btn btn-registrar-pago"
            @click="handleSubmitPago()"
          >
            Registrar Pago
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlanPago from "../PlanPago.vue";

export default {
  name: "HacerPagoModal",
  components: {
    PlanPago,
  },
  props: {
    modalState: {
      type: Object,
      required: true,
    },
    actions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedFileName: "",
    };
  },
  computed: {
    hacerPagoInfo() {
      return this.modalState.hacerPagoInfo || {};
    },
    pagoInfoReady() {
      return Boolean(
        this.hacerPagoInfo?.dni ||
          this.hacerPagoInfo?.nombres ||
          this.hacerPagoInfo?.idCredito
      );
    },
    bancos() {
      return this.modalState.bancos || [];
    },
    numerosDeCuenta() {
      return this.modalState.numerosDeCuenta || [];
    },
    fechaUltimoPago() {
      return this.modalState.fechaUltimoPago;
    },
    moneda() {
      return this.modalState.moneda;
    },
    tipoPago: {
      get() {
        return this.modalState.tipoPago;
      },
      set(value) {
        this.setState("tipoPago", value);
      },
    },
    fechaPagado: {
      get() {
        return this.modalState.fechaPagado;
      },
      set(value) {
        this.setState("fechaPagado", value);
      },
    },
    montoPagado: {
      get() {
        return this.modalState.montoPagado;
      },
      set(value) {
        this.setState("montoPagado", value);
      },
    },
    nombreBanco: {
      get() {
        return this.modalState.nombreBanco;
      },
      set(value) {
        this.setState("nombreBanco", value);
      },
    },
    noCuenta: {
      get() {
        return this.modalState.noCuenta;
      },
      set(value) {
        this.setState("noCuenta", value);
      },
    },
    noReferenciaRecibo: {
      get() {
        return this.modalState.noReferenciaRecibo;
      },
      set(value) {
        this.setState("noReferenciaRecibo", value);
      },
    },
    slug() {
      return this.modalState.slug;
    },
    imgPath() {
      return this.modalState.imgPath;
    },
    isLoading() {
      return this.modalState.isLoading;
    },
    imagenPegada() {
      return this.modalState.imagenPegada;
    },
    Consultor() {
      return this.modalState.Consultor;
    },
    Admin() {
      return this.modalState.Admin;
    },
    modoThanos() {
      return this.modalState.modoThanos;
    },
  },
  methods: {
    setState(key, value) {
      if (this.actions.setState) {
        this.actions.setState(key, value);
      }
    },
    dateFormat(param) {
      return this.actions.dateFormat ? this.actions.dateFormat(param) : "";
    },
    formatoNumero(numero) {
      return this.actions.formatoNumero ? this.actions.formatoNumero(numero) : numero;
    },
    handleImprimirEstadoCuenta() {
      return this.actions.handleImprimirEstadoCuenta
        ? this.actions.handleImprimirEstadoCuenta()
        : null;
    },
    fechaPagadoHoy() {
      return this.actions.fechaPagadoHoy ? this.actions.fechaPagadoHoy() : null;
    },
    loadCoverImage(event) {
      this.selectedFileName = event?.target?.files?.[0]?.name || "";
      return this.actions.loadCoverImage ? this.actions.loadCoverImage(event) : null;
    },
    pegarImagen() {
      return this.actions.pegarImagen ? this.actions.pegarImagen() : null;
    },
    cleanData() {
      this.selectedFileName = "";
      return this.actions.cleanData ? this.actions.cleanData() : null;
    },
    handleSubmitPago() {
      return this.actions.handleSubmitPago ? this.actions.handleSubmitPago() : null;
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: min(1240px, calc(100vw - 1.25rem));
  width: min(1240px, calc(100vw - 1.25rem));
  min-height: calc(100dvh - 1rem);
  margin: 0.5rem auto;
  display: flex;
  align-items: center;
}

.modal-content {
  overflow: hidden;
  height: min(760px, calc(100dvh - 1rem));
  max-height: calc(100dvh - 1rem);
  border: none;
  border-radius: 24px;
  background: #f7f8fb;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.12);
}

.modal-header {
  gap: 12px;
  padding: 8px 12px;
  color: #111827;
  border-bottom: 1px solid #e5e7eb;
  background: linear-gradient(120deg, #f8fafc 0%, #eef2f7 100%);
}

.modal-title {
  color: #111827;
  font-size: 1.08rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.modal-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.modal-actions :deep(.btn-plan-pago) {
  align-self: center;
  margin: 0;
  padding: 6px 12px;
  font-size: 0.9rem;
  line-height: 1.2;
  text-align: center;
  border-radius: 6px;
}

.modal-actions :deep(.btn-plan-pago:disabled),
.btn-estado:disabled {
  pointer-events: none;
  opacity: 0.72;
  box-shadow: none;
}

.modal-header .btn-close {
  margin: 0;
  width: 30px;
  height: 30px;
  padding: 6px;
  border-radius: 6px;
  opacity: 0.72;
  filter: none;
}

.modal-body {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 8px;
  background: #f7f8fb;
}

.modal-footer {
  gap: 6px;
  padding: 6px 12px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
}

.pagos-text {
  color: #334155;
  font-size: 0.8rem;
  margin-bottom: 0;
  padding: 2px 5px;
}

.payment-layout {
  width: 100%;  
  height: 100%;
  --bs-gutter-x: 0.65rem;
  --bs-gutter-y: 0.65rem;
}

.payment-loading {
  display: flex;
  min-height: 360px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 700;
  text-align: center;
}

.payment-loading .spinner-border {
  width: 2rem;
  height: 2rem;
  border-width: 0.18rem;
}

.payment-loading p {
  margin: 0;
}

.credit-summary {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.client-plain {
  padding: 0 2px 2px;
}

.client-name {
  margin: 0;
  color: #111827;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.16;
}

.client-dni {
  margin: 1px 0 0;
  color: #64748b;
  font-size: 0.86rem;
  font-weight: 600;
}

.summary-group {
  padding: 6px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #f9fafb;
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.04);
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
}

.summary-grid-three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.summary-item {
  display: flex;
  min-height: 52px;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  padding: 7px 9px;
  border: 1px solid #edf2f7;
  border-radius: 9px;
  background: #ffffff;
  overflow-wrap: anywhere;
}

.summary-label {
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 800;
  line-height: 1.15;
}

.summary-value {
  color: #111827;
  font-size: 0.98rem;
  font-weight: 800;
  line-height: 1.14;
}

.summary-note {
  color: #6b7280;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.15;
}

.summary-status {
  align-self: flex-start;
  margin-top: 1px;
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 800;
}

.status-ok {
  color: #047857;
  background: #ecfdf5;
}

.status-late {
  color: #991b1b;
  background: #fef2f2;
}

.capital-expected {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 9px;
  border: 1px solid #d1d5db;
  border-radius: 11px;
  background: #f3f4f6;
  overflow-wrap: anywhere;
}

.capital-expected .summary-value {
  text-align: right;
}

.summary-totals {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px;
}

.client-totals {
  margin-top: 8px;
}

.total-card {
  display: flex;
  min-height: 64px;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #f8fafc;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
  overflow-wrap: anywhere;
}

.total-card-strong {
  border-color: #9ca3af;
  background: linear-gradient(180deg, #ffffff 0%, #f3f4f6 100%);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.1);
}

.total-label {
  color: #475569;
  font-size: 0.8rem;
  font-weight: 800;
  line-height: 1.15;
}

.total-value {
  color: #111827;
  font-size: 0.98rem;
  font-weight: 900;
  line-height: 1.14;
}

.registro-pago {
  padding: 8px;
  margin-top: 45px;
  border: 1px solid #e2e8f0;
  border-top: 3px solid #d1d5db;
  border-radius: 12px;
  background: #ffffff;
  font-size: 0.8rem;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
}

.registro-pago h5 {
  color: #111827;
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.registro-pago .control {
  margin-bottom: 7px;
}

.registro-pago label {
  color: #334155;
  font-weight: 600;
  margin-bottom: 1px;
}

.registro-pago .form-check {
  min-width: 0;
}

.registro-pago .mb-3 {
  margin-bottom: 0.45rem !important;
}

.registro-pago .form-label {
  margin-bottom: 1px;
}

.form-control {
  height: 32px;
  min-height: 32px;
  margin-bottom: 4px;
  padding: 4px 9px;
  font-size: 0.8rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #334155;
}

.form-control:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 0.16rem rgba(15, 23, 42, 0.08);
}

.form-select {
  height: 32px;
  min-height: 32px;
  margin-bottom: 4px;
  padding: 4px 28px 4px 9px;
  font-size: 0.8rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  color: #334155;
}

.form-select:focus {
  border-color: #94a3b8;
  box-shadow: 0 0 0 0.16rem rgba(15, 23, 42, 0.08);
}

.native-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
}

.custom-file-control {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  min-height: 32px;
  margin-bottom: 4px;
  padding: 4px 9px;
  color: #334155;
  font-size: 0.8rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  text-align: center;
}

.custom-file-button {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 118px;
  padding: 3px 8px;
  color: #111827;
  font-size: 0.76rem;
  font-weight: 700;
  line-height: 1.1;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #f8fafc;
  text-align: center;
}

.custom-file-name {
  min-width: 0;
  flex: 1 1 auto;
  color: #64748b;
  font-size: 0.76rem;
  font-weight: 600;
  line-height: 1.1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.imagen-recibo {
  width: 80%;
  max-height: 86px;
  margin-top: 5px;
  border: 1px solid #e2e8f0;
  border-radius: 9px;
  object-fit: contain;
}

.book-cover {
  border-radius: 12px;
  border-color: #e2e8f0;
}

.btn.dayHoy {
  font-size: 0.76rem;
  height: auto;
  padding: 3px 8px;
  border: none;
  border-radius: 6px;
  background: #111827;
  transform: translateY(-4px);
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-weight: 600;
  padding: 6px 12px;
  font-size: 0.9rem;
  line-height: 1.2;
}

.btn-estado {
  color: #ffffff;
  border-color: #248d5d;
  background: #248d5d;
  box-shadow: 0 8px 18px rgba(36, 141, 93, 0.18);
}

.btn-estado:hover,
.btn-estado:active,
.btn-estado:focus {
  color: #ffffff;
  border-color: #1f7a51;
  background: #1f7a51;
}

.btn-pegar-imagen {
  color: #ffffff;
  border-color: #2563eb;
  background: #2563eb;
  box-shadow: 0 8px 18px rgba(37, 99, 235, 0.18);
}

.btn-pegar-imagen:hover,
.btn-pegar-imagen:active,
.btn-pegar-imagen:focus {
  color: #ffffff;
  border-color: #1d4ed8;
  background: #1d4ed8;
}

.btn-registrar-pago {
  color: #ffffff;
  border-color: #0f766e;
  background: #0f766e;
  box-shadow: 0 8px 18px rgba(15, 118, 110, 0.18);
}

.btn-registrar-pago:hover,
.btn-registrar-pago:active,
.btn-registrar-pago:focus {
  color: #ffffff;
  border-color: #0d665f;
  background: #0d665f;
}

.btn-registrar-pago:disabled {
  color: #ffffff;
  border-color: #99b9b5;
  background: #99b9b5;
  opacity: 0.85;
}

.estado-verificado {
  flex: 1;
  color: #991b1b;
}

@media (min-width: 992px) {
  .modal-dialog-scrollable .modal-content {
    height: min(760px, calc(100dvh - 1rem));
    max-height: calc(100dvh - 1rem);
  }

  .modal-dialog-scrollable .modal-body {
    overflow-y: auto;
  }
}

@media (max-width: 991.98px) {
  .modal-header {
    align-items: flex-start !important;
  }

  .modal-actions {
    justify-content: flex-start;
  }

  .btn-estado {
    margin-right: 0 !important;
  }

  .registro-pago {
    margin-top: 16px;
  }
}

@media (max-width: 575.98px) {
  .modal-dialog {
    max-width: calc(100vw - 0.75rem);
    width: calc(100vw - 0.75rem);
    min-height: calc(100dvh - 0.75rem);
    margin: 0.375rem auto;
  }

  .modal-content {
    height: calc(100dvh - 0.75rem);
    max-height: calc(100dvh - 0.75rem);
    border-radius: 18px;
  }

  .modal-header {
    flex-direction: column;
  }

  .modal-actions {
    width: 100%;
  }

  .modal-actions :deep(.btn-plan-pago),
  .modal-actions .btn-estado {
    flex: 1 1 150px;
  }

  .modal-header .btn-close {
    align-self: flex-end;
  }

  .modal-body {
    padding: 12px;
  }

  .summary-grid,
  .summary-grid-three,
  .summary-totals {
    grid-template-columns: 1fr;
  }

  .capital-expected {
    align-items: flex-start;
    flex-direction: column;
  }

  .capital-expected .summary-value {
    text-align: left;
  }

  .registro-pago {
    padding: 14px;
  }

  .registro-pago .d-flex.justify-content-between {
    flex-wrap: wrap;
    gap: 8px;
  }

  .modal-footer {
    justify-content: stretch;
  }

  .modal-footer .btn {
    flex: 1 1 140px;
  }
}
</style>
